import { PermissionGroup } from '@permissions/permission-group';
import { permissionsGroup as extraPermissionsGroup } from './extra-info';
import { permissionGroup as profilePermissionsGroup } from './api';

export const profileOtherPagePermissionsGroup = new PermissionGroup({
  operator: 'OR',
  groups: [extraPermissionsGroup, profilePermissionsGroup],
  marker: 'layout:profile-other-page',
});
